import { ConsumerHandshake } from '../Handshake';
import { AbstractConsumerEndpoint } from './AbstractEndpoint';
import { ConsumerChannel } from '../ConsumerChannel';

export class WorkerConsumerEndpoint extends AbstractConsumerEndpoint {
  static exposeAPI<TApi>(instance: TApi) {
    const consumer = new WorkerConsumerEndpoint();

    consumer.onConnect((port) => {
      const transport = new ConsumerChannel(port);
      transport.expose(instance);
    });
  }

  handshake = new ConsumerHandshake(
    (msg) => {
      globalThis.postMessage(msg);
    },
    (listener) => {
      globalThis.addEventListener('message', listener);
    },
  );
}
